import React, { useCallback } from "react"
import { Application, Button } from "@theguarantors/ui-kit-v2/dist"
import { defaultMenuItems, menuItemsForNoApartment } from "../../constants/menu"
import { FormStep } from "@theguarantors/ui-kit-v2/dist/components/FormStep"
import { SmileIcon } from "@theguarantors/ui-kit-v2/dist/components/icons"
import { FeatureFlag, useFeatureFlag } from "../../hooks/use-feature-flag"
import { HeaderV2 } from "@theguarantors/ui-kit-v2/dist/layout/HeaderV2"
import { Footer } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form/Footer"
import { Content } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form/Content"
import { useHistoryActions } from "../../history"

interface Props {
  renterEmail?: string
}

export const ThankYouComponent: React.FC<Props> = ({ renterEmail }) => {
  const { goToSignUpPage } = useHistoryActions()
  const startQuestionnaire = useCallback(() => {
    if (window && window.analytics) {
      window.analytics.track("Start Questionnaire Button", {})
    }
    return goToSignUpPage(renterEmail)
  }, [renterEmail, goToSignUpPage])
  const [rebrandV2MonolithReact] = useFeatureFlag(FeatureFlag.REBRAND_V2_MONOLITH_REACT)
  const rebrandV2MonolithReactFeatureFlag: Boolean = rebrandV2MonolithReact === "on"

  const ThankyouPageForm = () => (
    <FormStep.Wrapper>
      <FormStep.Icon>
        <SmileIcon />
      </FormStep.Icon>
      <FormStep.Title>Thank you!</FormStep.Title>
      <FormStep.Subtitle>
        <p>Our team is reviewing your application and will be reaching out shortly.</p>
        <p>
          Speed up your application process with TheGuarantors by completing our short questionnaire. Click on the
          button below to start
        </p>
      </FormStep.Subtitle>
      <FormStep.Actions>
        <Button
          data-testid="start-questionnaire-button"
          variant={rebrandV2MonolithReactFeatureFlag ? "v2_primary" : "primary"}
          onClick={startQuestionnaire}
          isFullWidth
          type="button"
        >
          Start Questionnaire
        </Button>
      </FormStep.Actions>
    </FormStep.Wrapper>
  )
  const NewHeader = () => (
    <>
      <HeaderV2 couper={[<></>, <></>]} menuItems={menuItemsForNoApartment} />
      <Content data-testid="thankyou-page">
        <ThankyouPageForm />
      </Content>
      <Footer />
    </>
  )

  return rebrandV2MonolithReactFeatureFlag ? (
    <NewHeader />
  ) : (
    <Application data-testid="thankyou-page" headerMenuItems={defaultMenuItems}>
      {" "}
      <ThankyouPageForm />
    </Application>
  )
}
